import {
  WheelGameRisk,
  WheelGameSegments,
} from '@/components/games/wheel/types'
import generateFloat from '../generateFloat'

export type CalculateWheelBetResultOptions = {
  serverSeed: string
  clientSeed: string
  nonce: number
  risk: WheelGameRisk
  segments: WheelGameSegments
}

export default function calculateWheelBetResult(
  options: CalculateWheelBetResultOptions
) {
  const { serverSeed, clientSeed, nonce, risk, segments } = options

  const float = generateFloat({ serverSeed, clientSeed, nonce })

  const payoutIndex = Math.floor(float * segments)

  return payoutIndex
}
